(function(window, angular) {
    'use strict';

    angular.module('test.bluemoon.dms.communications', []).provider('dms-app', function() {
        return {
            $get: function() {
                return {
                    set: function() {
                        return {
                            then: function() {}
                        };
                    }
                };
            }
        };
    });

})(window, window.angular);
